import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";

function contextRows(lightContext = {}) {
  return [
    {
      label: "Active days this week",
      value: String(lightContext.active_days_this_week || 0),
    },
    {
      label: "Last activity",
      value: lightContext.last_activity_label || "Hasn't shown up recently",
    },
  ];
}

export default function PersonRelationshipCard({ relationshipState, lightContext }) {
  const activeSprint = relationshipState?.kind === "active_sprint";
  return (
    <Box
      sx={{
        borderRadius: 4,
        border: "1px solid rgba(224, 231, 240, 0.92)",
        bgcolor: "#fff",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
        p: { xs: 2, md: 2.4 },
      }}
    >
      <Stack spacing={1.4}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: 800, color: "#16213f" }}>
            Relationship
          </Typography>
          <Chip
            label={activeSprint ? "Active Accountability" : relationshipState?.kind === "previous_sprint" ? "Previous Accountability" : "Connected"}
            sx={{
              height: 28,
              bgcolor: activeSprint ? "rgba(46, 139, 118, 0.12)" : "rgba(23, 52, 93, 0.08)",
              color: activeSprint ? "#1b6a48" : "#17345d",
              fontWeight: 800,
            }}
          />
        </Stack>
        <Typography variant="body2" sx={{ color: "#5f7085" }}>
          {relationshipState?.message || "You're connected here."}
        </Typography>
        <Stack spacing={0.9}>
          {contextRows(lightContext).map((row) => (
            <Stack
              key={row.label}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                px: 1.2,
                py: 1.1,
                borderRadius: 2.5,
                bgcolor: "#f8fbfe",
                gap: 2,
              }}
            >
              <Typography variant="body2" sx={{ color: "#70839a", fontWeight: 700 }}>
                {row.label}
              </Typography>
              <Typography variant="body2" sx={{ color: "#13233c", fontWeight: 800, textAlign: "right" }}>
                {row.value}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
